/** Display helpers — money, dates, statuses. */

const MYR = new Intl.NumberFormat('en-MY', {
  style: 'currency',
  currency: 'MYR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const NUM = new Intl.NumberFormat('en-MY', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export function money(v: number | null | undefined, currency = 'MYR'): string {
  if (v == null || !Number.isFinite(v)) return '—';
  if (currency === 'MYR') return MYR.format(v);
  return `${currency} ${NUM.format(v)}`;
}

export function num(v: number | null | undefined): string {
  if (v == null || !Number.isFinite(v)) return '—';
  return NUM.format(v);
}

// All timestamps in MySQL are UTC. Dashboard displays in Asia/Kuala_Lumpur
// (UTC+8, no DST) — that's where the user, the data, and the OBM ERP all live.
const KL_DATE = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Kuala_Lumpur',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});
const KL_DATETIME = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Kuala_Lumpur',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

export function dateOnly(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return KL_DATE.format(d);
}

export function dateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  // en-GB renders this as "DD/MM/YYYY, HH:mm" — strip the comma for compactness.
  return KL_DATETIME.format(d).replace(',', '');
}

const STATUS_LABEL: Record<string, string> = {
  W: 'New',
  X: 'Cancelled',
  A: 'Pending',
  O: 'Open',
  D: 'Declined',
  C: 'Closed',
  N: 'Active',
  P: 'Paid',
};

export function statusLabel(s: string | null | undefined): string {
  if (!s) return '—';
  return STATUS_LABEL[s] ?? s;
}

export function statusClass(s: string | null | undefined): string {
  if (!s) return 'badge-neutral';
  if (s === 'C' || s === 'P') return 'badge-ok';
  if (s === 'X' || s === 'D') return 'badge-cancel';
  if (s === 'A' || s === 'W') return 'badge-pending';
  return 'badge-neutral';
}
